<p-toast key="rechercheAdresse"></p-toast>


<div #contenu >
<div class="fluid formgrid grid">
    <div class="flex flex-column gap-2 col-12 md:col-6">
        <label for="numero">Numéro</label>
        <input #champNumero autofocus type="text" pInputText id="numero" [(ngModel)]="numero" autocomplete="off" (keyup.enter)="confirmer()" />
    </div>
    <div class="flex flex-column gap-2 col-12 md:col-6">
        <label for="codePostal">Code postal</label>
        <input type="text" pInputText id="codePostal" [(ngModel)]="codePostal" autocomplete="off" (keyup.enter)="confirmer()" />
    </div>
</div>
<div class="grid mt-4">
    <div class="col-12 text-right ">
        <button pButton pRipple label="Rechercher" icon="pi pi-save" class="p-button-primary" [disabled]="!numero || !codePostal"
        (click)="confirmer()"></button>
        <button pButton pRipple label="Annuler" icon="pi pi-ban" class="p-button-text" (click)="annuler()"></button>
    </div>
</div>
</div>